// Utilities
import createServiceAsyncThunk from "../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../utils/reduxUtils/createEntitySlice";

// Service
import { centerListService } from "../../../Api/Services/CenterListService/CenterListService"; // Importing the service to fetch center list data

// Types
import { ICentersListRepsonse } from "../../../Types/Center";

// Constants
import { ACTION_NAMES, SLICE_NAMES } from "../../../constants/action";
import { ERROR_MESSAGES } from "../../../constants/error";

/**
 * Async thunk to fetch center list.
 * Dispatches an API call to retrieve the center list data.
 */
export const fetchCenterListAsyncThunk = createServiceAsyncThunk<
  ICentersListRepsonse, // Repsonse Type,
  void // Payload Type
>(
  ACTION_NAMES.FETCH_CENTERS_LIST, // Action Name
  () => centerListService.getAllCenters(), // API Call
  ERROR_MESSAGES.CENTERS_LIST_FETCH_FAILURE // Error Message
);
// Creating the slice for managing the center list state
const centerSlice = createGenericSlice<ICentersListRepsonse, void>(
  SLICE_NAMES.CENTERS_LIST, // Slice Name
  fetchCenterListAsyncThunk // Async Thunk
);

// Export actions for dispatching
export const { clearError: clearCenterListError } = centerSlice.actions;

// Export the reducer to be used in the Redux store
export default centerSlice.reducer;
